import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAdminWorkers } from '../../../../reducers/admin';
import { bindActionCreators } from 'redux';
import { getGreeting } from './../../../../utilities/string';
import DashboardAlerts from './../../components/alerts';
import OnboardingList from './../../components/workers/onboarding';
import ExpirationsList from './../../components/workers/expirations';
import { expiringFilter, onboardingFilter, hideFilter } from '../../../../utilities/filterJobExt';

class AdminDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        const { role, getAdminWorkers } = this.props;

        getAdminWorkers(role.id);
    }

    render() {
        const { employments } = this.props;

        const { user } = this.props;

        const expWorkers = employments.filter(expiringFilter);
        const onboarding = employments
            .filter(onboardingFilter)
            .filter(hideFilter('onboarding'))
            .filter(hideFilter('onboarding_admin'));

        return (
            <React.Fragment>
                <div className="row greeting">
                    <div className="col-xs-12 col-sm-8">
                        <span className="greeting-message">
                            {getGreeting()} {user.first_name}
                        </span>
                    </div>
                </div>
                <div className="row section">
                    <div className="col-md-8 col-xs-12">
                        {/* <HighPriorityAlerts /> */}
                        <OnboardingList {...this.props} workers={onboarding} tenant="admin" />
                        <ExpirationsList {...this.props} workers={expWorkers} tenant="admin" />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <DashboardAlerts />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

AdminDashboard.defaultProps = {
    role: undefined
};
AdminDashboard.propTypes = {
    role: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    const role = state.identity.role;
    const employments = state.admin.workers || [];

    return {
        role,
        employments
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdminWorkers
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard);



// WEBPACK FOOTER //
// ./src/pages/dashboard/tenants/admin/index.jsx